import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './table-context-v2.component.scss';
import * as $ from 'jquery';
var TableContextV2 = /** @class */ (function (_super) {
    tslib_1.__extends(TableContextV2, _super);
    function TableContextV2(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    TableContextV2.prototype.init = function () {
        this.tables = Array.from(this.element.querySelectorAll('.table'));
        this.modals = Array.from(this.element.querySelectorAll('.js-table-popup-v2-modal'));
        this.modalContent = Array.from(this.element.querySelectorAll('.table-popup-v2__modal-content'));
        this.modalLinks = Array.from(document.querySelectorAll('.js-table-popup-v2-modal-open'));
        this.closeButton = this.element.querySelector('.js-table-popup-v2-modal-close');
    };
    TableContextV2.prototype.bindEvents = function () {
        // this.tables.map((item) => item.addEventListener('mousewheel', (event) => {
        // 	this.scrollHorizontally(event);
        // }));
        var _this = this;
        // this.tables.map((item) => item.addEventListener('DOMMouseScroll', (event) => {
        // 	this.scrollHorizontally(event);
        // }));
        // this.tables.map((item) => item.addEventListener('onmousewheel', (event) => {
        // 	this.scrollHorizontally(event);
        // }));
        this.modals.map(function (item) { return item.addEventListener('click', function (event) {
            _this.isClickOutsideModal(event);
        }); });
        this.closeButton.addEventListener('click', function (event) { return _this.closeModal(); });
        this.modalLinks.map(function (item) { return item.addEventListener('click', function (event) {
            _this.openModals(event);
        }); });
        this.modalContent.map(function (item) { return item.addEventListener('scroll', function (event) {
            _this.staticHeader();
        }); });
    };
    TableContextV2.prototype.isClickOutsideModal = function (event) {
        if (event.target === this.activeModal) {
            this.closeModal();
        }
    };
    TableContextV2.prototype.openModals = function (event) {
        var element = event.target;
        var modalId = element.getAttribute('data-modal');
        if (!modalId) {
            var parentElement = $(element).closest('.js-table-popup-v2-modal-open');
            modalId = parentElement.attr('data-modal');
        }
        this.activeModal = this.getModalById(modalId);
        this.openModal();
    };
    TableContextV2.prototype.closeModal = function () {
        var _this = this;
        this.activeModal.classList.add('modal--close');
        setTimeout(function () {
            _this.activeModal.classList.add('modal--closed');
        }, 250);
    };
    TableContextV2.prototype.openModal = function () {
        this.activeModal.classList.remove('modal--close');
        this.activeModal.classList.remove('modal--closed');
    };
    TableContextV2.prototype.getModalById = function (id) {
        return document.querySelector("#" + id);
    };
    TableContextV2.prototype.scrollHorizontally = function (event) {
        event = window.event || event;
        var delta = Math.max(-1, Math.min(1, (event.wheelDelta || -event.detail)));
        event.currentTarget.scrollLeft -= (delta * 40); // Multiplied by 40
        event.preventDefault();
    };
    TableContextV2.prototype.staticHeader = function () {
        var popup = document.querySelector('.js-table-popup-v2-modal-window');
        var table = document.querySelectorAll('.static_header');
        var tableHead = document.querySelectorAll('.static_header thead');
        var tableBody = document.querySelectorAll('.static_header tbody');
        var fixedHeader = document.querySelectorAll('.static_header .fixed');
        // const offset = table.getBoundingClientRect();
        for (var i = 0; i < table.length; ++i) {
            var offsetBody = tableBody[i].getBoundingClientRect();
            var windowOffset = popup.getBoundingClientRect();
            if (windowOffset.top >= offsetBody.top) {
                table[i].classList.add('static_header__top');
                tableHead[i].classList.add('fixed');
                if (popup.clientWidth > 767) {
                    tableHead[i].setAttribute('style', 'top: ' + ((windowOffset.top + 40) - offsetBody.top) + 'px !important;');
                }
                else {
                    tableHead[i].setAttribute('style', 'top: ' + (windowOffset.top - offsetBody.top) + 'px !important;');
                }
            }
            else {
                table[i].classList.remove('static_header__top');
                tableHead[i].classList.remove('fixed');
                tableHead[i].setAttribute('style', '');
            }
            if (windowOffset.top >= offsetBody.bottom) {
                table[i].classList.remove('static_header__top');
                tableHead[i].classList.remove('fixed');
                tableHead[i].setAttribute('style', '');
            }
        }
        if (fixedHeader != null) {
            $(tableBody).find('tr').first().children().each(function (i, e) {
                $($(fixedHeader).find('tr').children()[i]).width($(e).width() - 1);
            });
        }
    };
    return TableContextV2;
}(Base));
export { TableContextV2 };



//////////////////
// WEBPACK FOOTER
// ./components/table-context-v2/table-context-v2.component.ts
// module id = 701
// module chunks = 0